import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";

const SearchDate = ({ size, startDate, setStartDate, endDate, setEndDate }) => {
  return (
    <div className={`col-12 ${size}`}>
      <div className="block text-center sm:flex w-full justify-between items-center">
        <MuiPickersUtilsProvider utils={DateFnsUtils} className="w-full">
          <KeyboardDatePicker
            margin="normal"
            // id={`date-picker-dialog1${id}`}
            format="MM/dd/yyyy"
            value={startDate}
            onChange={(e) => setStartDate(e)}
            className="w-full"
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>
        <span className="px-2 font-bold text-555">~</span>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            // id={`date-picker-dialog2${id}`}
            format="MM/dd/yyyy"
            value={endDate}
            onChange={(e) => setEndDate(e)}
            className="w-full"
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
    </div>
  );
};

export default SearchDate;
